// shipping.js
document.addEventListener('DOMContentLoaded',  updateShippingText);
document.addEventListener('variant:change',     updateShippingText);

function updateShippingText() {
  document.querySelectorAll('.collapsible[data-days-min]').forEach(header => {
    const min  = parseInt(header.dataset.daysMin, 10);
    const max  = parseInt(header.dataset.daysMax, 10);
    const lang = document.documentElement.lang || 'en';
    moment.locale(lang);

    // calcola giorni lavorativi
    const addBusinessDays = (start, n) => {
      let added = 0, d = start.clone();
      while (added < n) {
        d.add(1, 'day');
        if (![6,7].includes(d.isoWeekday())) added++;
      }
      return d;
    };

    const dMin = addBusinessDays(moment(), min);
    const dMax = addBusinessDays(moment(), max);

    const text = lang === 'it'
      ? `Se ordini oggi lo spediremo fra <strong>${dMin.format('dddd D MMMM')}</strong> e <strong>${dMax.format('dddd D MMMM')}</strong>`
      : `If you order today we will ship on <strong>${dMin.format('dddd D MMMM')}</strong> - <strong>${dMax.format('dddd D MMMM')}</strong>`;

    const pid  = header.id.replace('shipping-header-', '');
    const span = document.getElementById(`shippingText-${pid}`);
    if (span) span.innerHTML = text;
  });
}
